import universal from 'react-universal-component';
import { LoadingComponent } from '../../components/LoadingComponent';
import React from 'react';

export default universal(() => import('./PrintProjections'), {loading: <LoadingComponent />});



// WEBPACK FOOTER //
// ./src/app/views/PrintProjections/index.js